import { useBillingRepository } from '@Hooks/useRepository';
import type { ApiExportOption } from '@Model';
import { BillingExportRepository } from '@Repositories/Billing';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

export interface ExportOptionsInfo {
    exportOptions: ApiExportOption[];
    refetch: () => void;
    hasExportOptions: boolean;
    currentExportOption: ApiExportOption | undefined;
    setCurrentExportOption: (exportOption: ApiExportOption | undefined) => void;
    resourceBasePath: string;
}

export function useExportOptions(resourceBasePath: string, category: string): ExportOptionsInfo {
    const [currentExportOption, setCurrentExportOption] = useState<ApiExportOption>();

    const exportsRepository = useBillingRepository(BillingExportRepository);

    const { data: queryResult, refetch } = useQuery({
        queryFn: () => exportsRepository.availableExports(category),
        queryKey: ['exports', 'categories', category],
    });

    const exportOptions = queryResult?.data ?? [];
    const hasExportOptions = exportOptions.length > 0;

    return {
        exportOptions,
        hasExportOptions,
        refetch,
        currentExportOption,
        setCurrentExportOption,
        resourceBasePath,
    };
}
